import { useLocation } from 'react-router-dom';
import cn from 'classnames';
import { Button } from '../Button';
import styles from './NavigationPath.module.scss';
import { Icon } from '../Icon/Icon';

interface CostumPath {
  name?: string;
  navigateTo?: string;
  isDisabled?: boolean;
}

interface NavigationPathProps {
  homeName?: string;
  costumPath?: CostumPath[];
  omitHome?: boolean;
  classname?: string;
}

export const NavigationPath = ({
  homeName = null,
  omitHome = true,
  costumPath = null,
  classname = '',
}: NavigationPathProps) => {
  const location = useLocation();
  const formatPathName = (path: string) =>
    path
      .split('-')
      .filter(Boolean)
      .map((item) => `${item[0].toUpperCase()}${item.slice(1)}`)
      .join(' ');

  const pathSegments = location.pathname.split('/').filter(Boolean);
  const generatedPath: CostumPath[] = [
    {
      name: homeName || 'Home',
      navigateTo: '/',
    },
    ...pathSegments.map((path, index) => ({
      name: formatPathName(path),
      navigateTo: `/${pathSegments.slice(0, index + 1).join('/')}`,
    })),
  ].filter((item, index) => index >= (omitHome ? 1 : 0));

  const renderPathItem = (
    path: CostumPath,
    index: number,
    paths: CostumPath[]
  ) => {
    const isCurrent = index === paths.length - 1;

    return (
      <li
        aria-current={isCurrent ? 'page' : undefined}
        className={styles.item}
        key={`${path.name}-${path.navigateTo || index}`}
      >
        <Button
          className={cn(styles.button, isCurrent && styles['current-button'])}
          iconPlace="none"
          to={isCurrent ? undefined : path.navigateTo}
          isDisabled={path.isDisabled}
          alt={isCurrent ? path.name : `Go to ${path.name}`}
        >
          <span className={styles.label}>{path.name}</span>
        </Button>
        {!isCurrent && (
          <Icon classname={styles.icon} type="right-arrow" alt="Next page" />
        )}
      </li>
    );
  };

  const renderPath = () => {
    if (costumPath) {
      return costumPath.map(renderPathItem);
    }

    return generatedPath.map(renderPathItem);
  };

  return (
    <nav className={cn(styles.root, classname)} aria-label="Breadcrumb">
      <ol className={styles.list}>{renderPath()}</ol>
    </nav>
  );
};
